import type { SVGProps } from 'react';
import * as React from 'react';

const QRCorners = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={141}
    height={141}
    viewBox="0 0 141 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3312 0.308105C4.80833 0.308105 0.331177 4.78526 0.331177 10.3081V20.269C0.331177 21.3736 1.22661 22.269 2.33118 22.269C3.43575 22.269 4.33118 21.3736 4.33118 20.269V10.3081C4.33118 6.9944 7.01747 4.30811 10.3312 4.30811H20.5C21.6046 4.30811 22.5 3.41267 22.5 2.30811C22.5 1.20354 21.6046 0.308105 20.5 0.308105H10.3312ZM10.3312 140.071C4.80833 140.071 0.331177 135.594 0.331177 130.071V120.111C0.331177 119.006 1.22661 118.111 2.33118 118.111C3.43575 118.111 4.33118 119.006 4.33118 120.111V130.071C4.33118 133.385 7.01747 136.071 10.3312 136.071H20.5C21.6046 136.071 22.5 136.967 22.5 138.071C22.5 139.176 21.6046 140.071 20.5 140.071H10.3312ZM140.062 10.3081C140.062 4.78526 135.585 0.308105 130.062 0.308105H119.894C118.789 0.308105 117.894 1.20354 117.894 2.30811C117.894 3.41267 118.789 4.30811 119.894 4.30811H130.062C133.376 4.30811 136.062 6.9944 136.062 10.3081V20.269C136.062 21.3736 136.958 22.269 138.062 22.269C139.167 22.269 140.062 21.3736 140.062 20.269V10.3081ZM130.062 140.071C135.585 140.071 140.062 135.594 140.062 130.071V120.111C140.062 119.006 139.167 118.111 138.062 118.111C136.958 118.111 136.062 119.006 136.062 120.111V130.071C136.062 133.385 133.376 136.071 130.062 136.071H119.894C118.789 136.071 117.894 136.967 117.894 138.071C117.894 139.176 118.789 140.071 119.894 140.071H130.062Z"
      fill="#818CF8"
    />
  </svg>
);
export default QRCorners;
